<script setup lang="ts">
import { ref } from 'vue';
import AuthFlow from '@/components/shared/AuthFlow.vue';
import { IProfile, IShift } from '@/interfaces';
import ReplaceShiftEmployeeOverlay from '@/views/workSchedule/ReplaceShiftEmployeeOverlay.vue';
import ReplaceShiftConfirmationOverlay from '@/views/workSchedule/ReplaceShiftConfirmationOverlay.vue';

interface Props {
  title: string;
  shift: IShift;
  loading: boolean;
}

withDefaults(defineProps<Props>(), {});

const showAuthFlow = ref<boolean>(false);
const showConfirmReplaceOverlay = ref<boolean>(false);
const selectedEmployee = ref<IProfile>();
const emit = defineEmits(['close', 'success']);

const closeFlow = () => {
  showConfirmReplaceOverlay.value = false;
  showAuthFlow.value = false;
  emit('close');
};

const employeeSelected = (employee: IProfile) => {
  showConfirmReplaceOverlay.value = true;
  selectedEmployee.value = employee;
};

const onSuccess = async () => {
  emit('success', selectedEmployee.value);
};
</script>

<template>
  <ReplaceShiftEmployeeOverlay
    @close="closeFlow()"
    @success="employeeSelected"
  />

  <ReplaceShiftConfirmationOverlay
    v-if="showConfirmReplaceOverlay && selectedEmployee"
    :newProfile="selectedEmployee"
    :oldProfile="shift.employee"
    @close="showConfirmReplaceOverlay = false"
    @success="showAuthFlow = true"
  />

  <AuthFlow
    v-if="showAuthFlow"
    :title="title"
    :employee-only="true"
    :loading="loading"
    @close="closeFlow"
    @authenticated="onSuccess"
  />
</template>
